import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import useHasPermission from "core/features/permissions/hooks/useHasPermission";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { TipoTenantEnum } from "core/resources/enums/tenant";

export interface AuthRouteProps extends RouteProps {
  permissions?: string[];
  tenantTypes?: TipoTenantEnum[];
}

const AuthRoute: React.FC<AuthRouteProps> = ({
  permissions,
  tenantTypes,
  ...props
}) => {
  const { isLogged } = useCurrentAuth();
  const { tenant } = useCurrentTenant();
  const hasPermission = useHasPermission(permissions ?? []);

  if (!isLogged) {
    return <Redirect to="/auth/login" />;
  }

  if (!tenant?.id) {
    return <Redirect to="/auth/selecionar-empresa" />;
  }

  if (permissions !== undefined && !hasPermission) {
    return <Redirect to="/errors/sem-permissao" />;
  }

  if (tenantTypes?.length && !tenantTypes.includes(tenant.tipoTenantId)) {
    return <Redirect to="/errors/sem-permissao" />;
  }

  return <Route {...props} />;
};

export default AuthRoute;
